export class LoanKeyDatesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getInfo({ loanId }) {
    return this.#http.get(`loan/${loanId}/key-dates`);
  }
}
